import React, { createContext, useContext, useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../../shared/storage/firebase';
import { LibraryItem } from '../types';

const Context = createContext<{ cards: LibraryItem[]; loading: boolean; error: string }>({ cards: [], loading: true, error: '' });
export const useSquadUniverseCards = () => useContext(Context);
export function SquadUniverseCards({ squadId, children }: { squadId: string; children: React.ReactNode }) {
  const [state, setState] = useState({ cards: [] as LibraryItem[], loading: true, error: '' });
  useEffect(() => {
    setState({ cards: [], loading: true, error: '' });
    return onSnapshot(query(collection(db, 'libraryItems'), where('squadId', '==', squadId)), snapshot => {
      setState({ cards: snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id } as LibraryItem)), loading: false, error: '' });
    }, () => setState({ cards: [], loading: false, error: 'Could not check Universe publication status. Try again after confirming access and deploying the latest Firestore rules.' }));
  }, [squadId]);
  return <Context.Provider value={state}>{children}</Context.Provider>;
}
